import { render, staticRenderFns } from "./semiology.vue?vue&type=template&id=4c4d51f4&scoped=true&"
import script from "./semiology.vue?vue&type=script&lang=js&"
export * from "./semiology.vue?vue&type=script&lang=js&"
import style0 from "./semiology.vue?vue&type=style&index=0&id=4c4d51f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d51f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
